export default "__VITE_ASSET__C07iyUT3__"